var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"mgA4rZQep_-Ma0SbZbayT"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const SENTRY_ENVIRONMENT = process.env.NEXT_PUBLIC_NODE_ENV || 'development';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  tracesSampleRate: 1.0, // Capture 100% of transactions for monitoring
  // Performance monitoring
  integrations: [
    new Sentry.BrowserTracing({
      // Set sampling based on environment
      tracesSampleRate: SENTRY_ENVIRONMENT === 'production' ? 0.2 : 1.0,
    }),
    new Sentry.Replay({
      // Additional replay configuration
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Capture Replay for errors and transaction
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
}); 